import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-3dbox",
  "use": "icon-icon-3dbox-usage",
  "viewBox": "0 0 13.2 14.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.2 14.5\" id=\"icon-icon-3dbox\">\r\n    <title>资源 119</title>\r\n    <g id=\"icon-icon-3dbox_图层_2\" data-name=\"图层 2\">\r\n        <g id=\"icon-icon-3dbox_图层_1-2\" data-name=\"图层 1\">\r\n            <path d=\"M6.8,7.1,12,3.7a.3.3,0,0,0,0-.6L6.8.1H6.4l-5.2,3a.3.3,0,0,0,0,.6L6.4,7.1Z\" />\r\n            <polygon points=\"0 3.8 0 3.8 0 3.8 0 3.8\" />\r\n            <path d=\"M5.8,8.2.6,4.9a.4.4,0,0,0-.6.3v6c0,.1.1.2.2.3l5.2,3c.2.1.5-.1.5-.4V8.5A.4.4,0,0,0,5.8,8.2Z\" />\r\n            <path d=\"M7.3,8.5v5.7a.4.4,0,0,0,.5.3l5.2-3c.1-.1.2-.2.2-.3v-6a.4.4,0,0,0-.6-.3L7.4,8.2A.4.4,0,0,0,7.3,8.5Z\" />\r\n        </g>\r\n    </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-3dbox.svg
// module id = 6WOt
// module chunks = 71